module.exports = __webpack_public_path__ + "media/images/logo-full-red-28597081b57f14acf058e8c99a418479.svg";